import React, { useState } from "react";
import HeaderName from "./HeaderName";
import SideBar from "./SideBar";
import { Outlet } from "react-router-dom";

const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  return (
    <div className="wrapper">
      <HeaderName
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
      />
      <SideBar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
      />
      <div
        className={isSidebarOpen ? "custom-content-wrapper" : ""}
        style={!isSidebarOpen ? { backgroundColor: "#f4f6f9" } : {}}
      >
        <Outlet />
      </div>
      <footer
        className={isSidebarOpen ? "custom-footer" : "custom-footer-close"}
      >
        <strong>
          Copyright &copy; 2017-2020{" "}
          <a href="http://www.kwintechnologies.com">K-win Technology</a>.{" "}
        </strong>
        All rights reserved.
      </footer>
    </div>
  );
};

export default Layout;
